/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LeadCalendarEvent } from './LeadCalendarEvent';
import {
    LeadCalendarEventFromJSON,
    LeadCalendarEventFromJSONTyped,
    LeadCalendarEventToJSON,
    LeadCalendarEventToJSONTyped,
} from './LeadCalendarEvent';

/**
 * 
 * @export
 * @interface LeadCalendarEventsFindAllResponse
 */
export interface LeadCalendarEventsFindAllResponse {
    /**
     * 
     */
    data: Array<LeadCalendarEvent>;
}

/**
 * Check if a given object implements the LeadCalendarEventsFindAllResponse interface.
 */
export function instanceOfLeadCalendarEventsFindAllResponse(value: object): value is LeadCalendarEventsFindAllResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function LeadCalendarEventsFindAllResponseFromJSON(json: any): LeadCalendarEventsFindAllResponse {
    return LeadCalendarEventsFindAllResponseFromJSONTyped(json, false);
}

export function LeadCalendarEventsFindAllResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): LeadCalendarEventsFindAllResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(LeadCalendarEventFromJSON)),
    };
}

export function LeadCalendarEventsFindAllResponseToJSON(json: any): LeadCalendarEventsFindAllResponse {
    return LeadCalendarEventsFindAllResponseToJSONTyped(json, false);
}

export function LeadCalendarEventsFindAllResponseToJSONTyped(value?: LeadCalendarEventsFindAllResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(LeadCalendarEventToJSON)),
    };
}

